import { render, staticRenderFns } from "./PlantingSocListFF.vue?vue&type=template&id=f9b954da"
import script from "./PlantingSocListFF.vue?vue&type=script&lang=js"
export * from "./PlantingSocListFF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports